import { createSelector } from 'reselect'

export const getCities = createSelector(
  (state) => state.geoObjects && state.geoObjects.cities && state.geoObjects.cities.elements
    ? state.geoObjects && state.geoObjects.cities && state.geoObjects.cities.elements
    : [],
  (cities) => cities
)
